import React, { useState } from 'react';
import { isCommunePersonneType } from '../../constants/communes';
import { optionsCivilite, optionsIndice } from '../../utils/selectOptions';

const InformationsDemandeur = ({
  formData,
  handleChange,
  handleTrimValue,
  handleChangeMandataireConfirm,
  handleChangeMandantConfirm,
  inputFocus,
  listeUrls3DOuest,
  setUrl3DOuest,
  url3DOuest,
  page,
  fetchDataToken,
}) => {
  const [urlData, setUrlData] = useState(
    JSON.parse(localStorage?.getItem('url_params')) || null
  );

  const isArcachon = formData.villeArcachonAutre === 'Arcachon';
  const isCommunePersType = isCommunePersonneType(formData.villeArcachonAutre);

  return (
    <>
      <header className="d-flex flex-column align-items-center justify-content-center pt-4 pb-4 header">
        <h1 className="title text-center">1. Informations sur le demandeur</h1>
        <div className="divider--title m-5"></div>
      </header>
      {/* Sélection de la commune */}
      <section className={`mb-5 ${urlData?.token ? 'd-none' : 'd-block'}`}>
        <div className="position-relative mb-5">
          <label htmlFor="villeArcachonAutre" className="mb-2 fw-bold">
            Dans quelle ville est situé votre bien&nbsp;?&nbsp;
            <span className="text-danger">*</span>
          </label>
          <select
            className="form-select page-1-required ville-group select-group getLabel"
            aria-label="Default select example"
            id="villeArcachonAutre"
            name="villeArcachonAutre"
            value={formData.villeArcachonAutre || ''}
            onChange={(e) => {
              const currentData = [...listeUrls3DOuest].find(
                (data) => data.ville === e.target.value
              );
              setUrl3DOuest(currentData);
              handleChange(e);
            }}
            onInput={inputFocus}
            data-group="mandataire"
            required
          >
            <option value="">Selectionnez une commune</option>
            {listeUrls3DOuest?.map((data) => {
              return (
                <option value={data.ville} key={data.ville}>
                  {data.ville}
                </option>
              );
            })}
          </select>
          <div className="invalid-tooltip">
            Veuillez remplir ce champs obligatoire
          </div>
        </div>
      </section>

      {/* Mandataire ? */}
      <section className={isArcachon ? 'd-block' : 'd-none'}>
        <label className="mb-2 fw-bold" htmlFor="MandataireOuiNon">
          Déposez-vous cette demande en tant que mandataire&nbsp;?&nbsp;
          <span className="text-danger">*</span>
        </label>
        <div className="form-check">
          <input
            className="form-check-input page-1-required radio-group mandataire-group getLabel"
            type="radio"
            id="MandataireOuiNon"
            name="MandataireOuiNon"
            value="Oui"
            onChange={handleChange}
            onInput={inputFocus}
            checked={formData.MandataireOuiNon === 'Oui'}
            data-group="mandataire"
          />
          <label className="form-check-label">oui</label>
        </div>
        <div className="form-check position-relative">
          <input
            className="form-check-input page-1-required radio-group mandataire-group getLabel"
            type="radio"
            id="MandataireOuiNon"
            name="MandataireOuiNon"
            value="Non"
            onChange={handleChange}
            onInput={inputFocus}
            checked={
              formData.MandataireOuiNon === 'Non' ||
              formData.villeArcachonAutre !== 'Arcachon'
            }
            data-group="mandataire"
          />
          <label className="form-check-label">non</label>
          <div className="invalid-tooltip">
            Veuillez remplir ce champs obligatoire
          </div>
        </div>
      </section>

      {/* Formulaire Mandataire */}
      <section
        className={
          (formData.MandataireOuiNon === 'Oui' && isArcachon) ||
          (urlData?.token && formData.MandataireOuiNon === 'Oui')
            ? 'pb-4 mt-4 d-block'
            : 'd-none'
        }
      >
        <p className="mb-4 fw-bold">Informations du mandataire&nbsp;:</p>
        <div className="background--warning p-3">
          <div className="row pb-4">
            <div className="col-12 col-md-2 position-relative">
              <label htmlFor="MandataireCivil" className="form-label">
                Civilité&nbsp;:&nbsp;<span className="text-danger">*</span>
              </label>
              <select
                className="form-select page-1-required mandataire-group getLabel"
                aria-label="Default select example"
                id="MandataireCivil"
                name="MandataireCivil"
                value={formData.MandataireCivil || ''}
                onChange={handleChange}
                onInput={inputFocus}
                required={formData.MandataireOuiNon === 'Oui' ? true : false}
              >
                <option defaultValue=""></option>
                <option value="M.">M.</option>
                <option value="Mme.">Mme.</option>
                <option value="Mlle.">Mlle.</option>
              </select>
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
            <div className="col-12 col-md-5 mt-3 mt-md-0 position-relative">
              <label htmlFor="MandatairePrenom" className="form-label">
                Prénom&nbsp;:&nbsp;<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control page-1-required mandataire-group getLabel"
                id="MandatairePrenom"
                name="MandatairePrenom"
                maxLength={30}
                value={formData.MandatairePrenom || ''}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
                required={formData.MandataireOuiNon === 'Oui' ? true : false}
              />
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
            <div className="col-12 col-md-5 mt-3 mt-md-0 position-relative">
              <label htmlFor="MandataireNom" className="form-label">
                Nom d'usage&nbsp;:&nbsp;<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control page-1-required mandataire-group getLabel"
                id="MandataireNom"
                name="MandataireNom"
                maxLength={30}
                value={formData.MandataireNom || ''}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
                required={formData.MandataireOuiNon === 'Oui' ? true : false}
              />
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
          </div>
          <div className="row pb-4">
            <div className="col-12 col-md-3 position-relative">
              <label htmlFor="MandataireAdrNum" className="form-label">
                Numéro de voie&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                pattern="[0-9]+"
                maxLength={5}
                className="form-control page-1-required mandataire-group inputReg getLabel"
                id="MandataireAdrNum"
                name="MandataireAdrNum"
                value={formData.MandataireAdrNum || ''}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
                required={formData.MandataireOuiNon === 'Oui' ? true : false}
              />
              <div className="invalid-tooltip">
                Veuillez entrer un numéro de voie valide
              </div>
            </div>
            <div className="col-12 col-md-3 mt-3 mt-md-0 position-relative">
              <label htmlFor="MandataireAdrRepetition" className="form-label">
                Indice de répétition&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <select
                className="form-select page-1-required mandataire-group getLabel"
                aria-label="Default select example"
                id="MandataireAdrRepetition"
                name="MandataireAdrRepetition"
                maxLength={50}
                value={formData.MandataireAdrRepetition || ''}
                onChange={handleChange}
                onInput={inputFocus}
                required={formData.MandataireOuiNon === 'Oui' ? true : false}
              >
                <option defaultValue=""></option>
                <option value="Aucun">Aucun</option>
                <option value="Bis">Bis</option>
                <option value="Ter">Ter</option>
                <option value="Quarter">Quarter</option>
              </select>
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
            <div className="col-12 col-md-6 mt-3 mt-md-0 position-relative">
              <label htmlFor="MandataireAdrRue" className="form-label">
                Type et nom de voie&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control page-1-required mandataire-group getLabel"
                id="MandataireAdrRue"
                name="MandataireAdrRue"
                maxLength={50}
                value={formData.MandataireAdrRue || ''}
                onInput={inputFocus}
                onChange={handleChange}
                onBlur={handleTrimValue}
                autoComplete="nope"
                required={formData.MandataireOuiNon === 'Oui' ? true : false}
              />
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
          </div>
          <div className="row pb-4">
            <div className="col-12 mt-3 mt-md-0 position-relative">
              <label htmlFor="MandataireAdrComp" className="form-label">
                Complément d'adresse{' '}
                <span className="text-danger">(facultatif)</span>&nbsp;:
              </label>
              <input
                type="text"
                className="form-control mandataire-group getLabel"
                id="MandataireAdrComp"
                name="MandataireAdrComp"
                maxLength={50}
                value={formData.MandataireAdrComp || ''}
                onInput={inputFocus}
                onChange={handleChange}
                onBlur={handleTrimValue}
                autoComplete="nope"
              />
            </div>
          </div>
          <div className="row pb-4">
            <div className="col-12 col-md-6 position-relative">
              <label htmlFor="MandataireAdrCP" className="form-label">
                Code postal&nbsp;:&nbsp;<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control page-1-required mandataire-group inputReg getLabel"
                id="MandataireAdrCP"
                name="MandataireAdrCP"
                value={formData.MandataireAdrCP || ''}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
                required={formData.MandataireOuiNon === 'Oui' ? true : false}
              />
              <div className="invalid-tooltip">
                Veuillez entrer un code postal valide
              </div>
            </div>
            <div className="col-12 col-md-6 mt-3 mt-md-0 position-relative">
              <label htmlFor="MandataireAdrVille" className="form-label">
                Commune&nbsp;:&nbsp;<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control page-1-required mandataire-group getLabel"
                id="MandataireAdrVille"
                name="MandataireAdrVille"
                maxLength={40}
                value={formData.MandataireAdrVille || ''}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
                required={formData.MandataireOuiNon === 'Oui' ? true : false}
              />
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
          </div>
          <div className="row pb-4">
            <div className="col-12 col-md-6 position-relative">
              <label htmlFor="MandataireEmail" className="form-label">
                Votre adresse e-mail&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <input
                type="email"
                className="form-control page-1-required mandataire-group inputReg getLabel"
                id="MandataireEmail"
                name="MandataireEmail"
                maxLength={40}
                value={formData.MandataireEmail || ''}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
                required={formData.MandataireOuiNon === 'Oui' ? true : false}
                placeholder="ex: email@example.com"
              />
              <div className="invalid-tooltip">
                Veuillez entrer une adresse email valide
              </div>
            </div>
            <div className="col-12 col-md-6 pt-3 pt-md-0 position-relative">
              <label htmlFor="MandataireEmailConfirme" className="form-label">
                Confirmer votre adresse e-mail&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <input
                type="email"
                className="form-control page-1-required confirmMandataireEmail mandataire-group getLabel"
                id="MandataireEmailConfirme"
                name="MandataireEmailConfirme"
                maxLength={40}
                value={formData.MandataireEmailConfirme || ''}
                onChange={handleChangeMandataireConfirm}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
                required={formData.MandataireOuiNon === 'Oui' ? true : false}
                onPaste={(e) => e.preventDefault()}
                placeholder="ex: email@example.com"
              />
              <div className="invalid-tooltip">
                Veuillez entrer une adresse email identique
              </div>
            </div>
          </div>
          <div className="row pb-4">
            <div className="col-12 mt-3 mt-md-0">
              <label htmlFor="MandataireRaisSos" className="form-label">
                Dénomination et raison sociale de votre société&nbsp;
                <span className="text-danger">(facultatif)</span>&nbsp;:
              </label>
              <input
                type="text"
                className="form-control mandataire-group getLabel"
                id="MandataireRaisSos"
                name="MandataireRaisSos"
                maxLength={50}
                value={formData.MandataireRaisSos || ''}
                onChange={handleChange}
                onBlur={handleTrimValue}
                autoComplete="nope"
              />
            </div>
          </div>
          <div className="row pb-4">
            <div className="col-12 mt-3 mt-md-0 position-relative">
              <label htmlFor="MandataireSiret" className="form-label">
                Numéro de Siret&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control mandataire-group page-1-required inputReg getLabel"
                id="MandataireSiret"
                name="MandataireSiret"
                maxLength={50}
                value={formData.MandataireSiret || ''}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                required={formData.MandataireOuiNon === 'Oui'}
                autoComplete="nope"
              />
              <div className="invalid-tooltip">
                Veuillez entrer un numéro de téléphone portable valide
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-6 position-relative">
              <label htmlFor="MandataireTel" className="form-label">
                Votre numéro de téléphone portable&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <input
                type="tel"
                pattern="[ +0-9]+"
                maxLength={15}
                className="form-control page-1-required mandataire-group inputReg getLabel"
                id="MandataireTel"
                name="MandataireTel"
                value={formData.MandataireTel || ''}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
                required={formData.MandataireOuiNon === 'Oui' ? true : false}
                placeholder="ex: 0601020304"
              />
              <div className="invalid-tooltip">
                Veuillez entrer un numéro de téléphone portable valide
              </div>
            </div>
            <div className="col-12 col-md-6 mt-3 mt-md-0 position-relative">
              <label htmlFor="MandataireTelFixe" className="form-label">
                Votre numéro de téléphone fixe{' '}
                <span className="text-danger">(facultatif)</span>&nbsp;:
              </label>
              <input
                type="tel"
                pattern="[ +0-9]+"
                maxLength={15}
                className="form-control page-1-required mandataire-group inputReg getLabel"
                id="MandataireTelFixe"
                name="MandataireTelFixe"
                value={formData.MandataireTelFixe || ''}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
                placeholder="ex: 0235010203"
              />
              <div className="invalid-tooltip">
                Veuillez entrer un numéro de téléphone valide
              </div>
            </div>
          </div>
        </div>
      </section>

      <div
        className={isArcachon ? 'd-block divider mt-5 mb-5' : 'd-none'}
      ></div>

      {/* Numéro d'enregistrement */}
      <section className="mt-5">
        <div className="position-relative">
          <label htmlFor="ProNumEnregistrement" className="form-label fw-bold">
            Le cas échéant, veuillez indiquer le numéro d’enregistrement de
            cette location meublée courte durée (location touristique) figurant
            sur vos annonces de location.
          </label>
          <input
            className="form-control page-1-required inputReg ProActivite-group getLabel"
            type="text"
            // pattern='[\d\-]+'
            maxLength={15}
            id="ProNumEnregistrement"
            name="ProNumEnregistrement"
            value={formData.ProNumEnregistrement || ''}
            onChange={handleChange}
            onInput={inputFocus}
            onBlur={handleTrimValue}
            autoComplete="nope"
            placeholder="N° d'enregistrement (ex: 12345-67, 123-456)"
          />
          <div className="invalid-tooltip">
            Veuillez entrer un numéro d'enregistrement valide
          </div>
        </div>

        <div className={page === 5 ? 'd-none' : 'alert alert-info mt-3'}>
          <i className="fas fa-info-circle"></i>&nbsp;
          <strong>Pour information :</strong>&nbsp;Le numéro d'enregistrement
          est un numéro délivré par la mairie de votre ville lors de la
          déclaration de votre location saisonnière. Pour en savoir plus,{' '}
          <a href={url3DOuest?.url} target="_blank" rel="noreferrer">
            Cliquez ici
          </a>
          .
        </div>
      </section>

      <div
        className={
          !formData.villeArcachonAutre ? 'd-none' : 'd-block divider mt-5 mb-5'
        }
      ></div>

      {/* Question : Personne Physique vs Personne Morale */}
      <section className={isCommunePersType ? 'd-block' : 'd-none'}>
        <label className="mb-2 fw-bold" htmlFor="PersonneType">
          Vous êtes&nbsp;:&nbsp;
          <span className="text-danger">*</span>
        </label>
        <div className="form-check">
          <input
            className={
              isCommunePersType
                ? 'form-check-input page-1-required radio-group getLabel'
                : 'form-check-input radio-group getLabel'
            }
            type="radio"
            id="PersonneType"
            name="PersonneType"
            value="Une personne physique"
            onChange={handleChange}
            onInput={inputFocus}
            checked={formData.PersonneType === 'Une personne physique'}
            data-group="mandant"
          />
          <label className="form-check-label">Une personne physique</label>
        </div>
        <div className="form-check position-relative">
          <input
            className={
              isCommunePersType
                ? 'form-check-input page-1-required radio-group getLabel'
                : 'form-check-input radio-group getLabel'
            }
            type="radio"
            id="PersonneType"
            name="PersonneType"
            value="Une personne morale"
            onChange={handleChange}
            onInput={inputFocus}
            checked={formData.PersonneType === 'Une personne morale'}
            data-group="mandant"
          />
          <label className="form-check-label">Une personne morale</label>
          <div className="invalid-tooltip">
            Veuillez remplir ce champs obligatoire
          </div>
        </div>
      </section>

      {/* Formulaire Personne Physique (demandeur pour tous) */}
      <section
        className={
          (formData.villeArcachonAutre &&
            formData.villeArcachonAutre !== '' &&
            !isCommunePersType) ||
          (isCommunePersType &&
            formData.PersonneType === 'Une personne physique') ||
          (urlData?.token && !isCommunePersType) ||
          (urlData?.token &&
            isCommunePersType &&
            formData.PersonneType === 'Une personne physique')
            ? 'mt-5 d-block'
            : 'd-none'
        }
      >
        <p className="mb-4">
          <strong>Informations du demandeur&nbsp;:</strong>
        </p>
        <div className="background--warning p-3">
          <div className="row pb-4">
            <div className="col-12 col-md-2 position-relative">
              <label htmlFor="MandantCivil" className="form-label">
                Civilité&nbsp;:&nbsp;<span className="text-danger">*</span>
              </label>
              <select
                className="form-select page-1-required deletP-group getLabel"
                aria-label="Default select example"
                id="MandantCivil"
                name="MandantCivil"
                value={formData.MandantCivil || ''}
                onChange={handleChange}
                onInput={inputFocus}
                required={formData.villeArcachonAutre !== ''}
              >
                <option defaultValue=""></option>
                <option value="M.">M.</option>
                <option value="Mme.">Mme.</option>
                <option value="Mlle.">Mlle.</option>
              </select>
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
            <div className="col-12 col-md-5 mt-3 mt-md-0 position-relative">
              <label htmlFor="MandantPrenom" className="form-label">
                Prénom&nbsp;:&nbsp;<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control page-1-required deletP-group getLabel"
                id="MandantPrenom"
                name="MandantPrenom"
                maxLength={30}
                value={formData.MandantPrenom || ''}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
                required={formData.villeArcachonAutre !== ''}
              />
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
            <div className="col-12 col-md-5 mt-3 mt-md-0 position-relative">
              <label htmlFor="MandantNom" className="form-label">
                Nom de famille&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control page-1-required deletP-group getLabel"
                id="MandantNom"
                name="MandantNom"
                maxLength={30}
                value={formData.MandantNom || ''}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
                required={formData.villeArcachonAutre !== ''}
              />
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
          </div>
          <div className="row pb-4">
            <div className="col-12">
              <label htmlFor="MandantNomNaissance" className="form-label">
                Nom de jeune fille{' '}
                <span className="text-danger">(le cas échéant)</span>&nbsp;:
              </label>
              <input
                type="text"
                className="form-control deletP-group getLabel"
                id="MandantNomNaissance"
                name="MandantNomNaissance"
                maxLength={30}
                value={formData.MandantNomNaissance || ''}
                onChange={handleChange}
                onBlur={handleTrimValue}
                autoComplete="nope"
              />
            </div>
          </div>
          <div className="row pb-4">
            <div className="col-12 col-md-3 position-relative">
              <label htmlFor="MandantAdrNum" className="form-label">
                Numéro de voie&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                pattern="[0-9]+"
                className="form-control page-1-required deletP-group inputReg getLabel"
                id="MandantAdrNum"
                name="MandantAdrNum"
                maxLength={5}
                value={formData.MandantAdrNum || ''}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
                required={formData.villeArcachonAutre !== ''}
              />
              <div className="invalid-tooltip">
                Veuillez entrer un numéro de voie valide
              </div>
            </div>
            <div className="col-12 col-md-3 mt-3 mt-md-0 position-relative">
              <label htmlFor="MandantAdrRepetition" className="form-label">
                Indice de répétition&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <select
                className="form-select page-1-required deletP-group getLabel"
                aria-label="Default select example"
                id="MandantAdrRepetition"
                name="MandantAdrRepetition"
                value={formData.MandantAdrRepetition || ''}
                onChange={handleChange}
                onInput={inputFocus}
                required={formData.villeArcachonAutre !== ''}
              >
                <option defaultValue=""></option>
                <option value="Aucun">Aucun</option>
                <option value="Bis">Bis</option>
                <option value="Ter">Ter</option>
                <option value="Quarter">Quarter</option>
              </select>
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
            <div className="col-12 col-md-6 mt-3 mt-md-0 position-relative">
              <label htmlFor="MandantAdrRue" className="form-label">
                Type et nom de voie&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control page-1-required deletP-group getLabel"
                id="MandantAdrRue"
                name="MandantAdrRue"
                maxLength={50}
                value={formData.MandantAdrRue || ''}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
                required={formData.villeArcachonAutre !== ''}
              />
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
          </div>
          <div className="row pb-4">
            <div className="col-12 mt-3 mt-md-0 position-relative">
              <label htmlFor="MandantAdrComp" className="form-label">
                Complément d'adresse{' '}
                <span className="text-danger">(facultatif)</span>&nbsp;:
              </label>
              <input
                type="text"
                className="form-control deletP-group getLabel"
                id="MandantAdrComp"
                name="MandantAdrComp"
                maxLength={50}
                value={formData.MandantAdrComp || ''}
                onInput={inputFocus}
                onChange={handleChange}
                onBlur={handleTrimValue}
                autoComplete="nope"
              />
            </div>
          </div>
          <div className="row pb-4">
            <div className="col-12 col-md-6 position-relative">
              <label htmlFor="MandantAdrCP" className="form-label">
                Code postal&nbsp;:&nbsp;<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control page-1-required deletP-group inputReg getLabel"
                id="MandantAdrCP"
                name="MandantAdrCP"
                value={formData.MandantAdrCP || ''}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
                required={formData.villeArcachonAutre !== ''}
              />
              <div className="invalid-tooltip">
                Veuillez entrer un code postal valide
              </div>
            </div>
            <div className="col-12 col-md-6 mt-3 mt-md-0 position-relative">
              <label htmlFor="MandantAdrVille" className="form-label">
                Commune&nbsp;:&nbsp;<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control page-1-required deletP-group getLabel"
                id="MandantAdrVille"
                name="MandantAdrVille"
                maxLength={40}
                value={formData.MandantAdrVille || ''}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
                required={formData.villeArcachonAutre !== ''}
              />
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
          </div>
          <div className="row pb-4">
            <div className="col-12 position-relative">
              <label htmlFor="MandantAdrPays" className="form-label">
                Pays&nbsp;:&nbsp;<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control page-1-required deletP-group getLabel"
                id="MandantAdrPays"
                name="MandantAdrPays"
                maxLength={30}
                value={formData.MandantAdrPays || ''}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
                required={formData.villeArcachonAutre !== ''}
              />
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
          </div>
          <div className="row pb-4">
            <div className="col-12 col-md-6 mt-3 mt-md-0 position-relative">
              <label htmlFor="MandantEmail" className="form-label">
                Votre adresse e-mail&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <input
                type="email"
                className="form-control page-1-required deletP-group inputReg getLabel"
                id="MandantEmail"
                name="MandantEmail"
                maxLength={40}
                value={formData.MandantEmail || ''}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
                required={formData.villeArcachonAutre !== ''}
                placeholder="ex: email@example.com"
              />
              <div className="invalid-tooltip">
                Veuillez entrer une adresse email valide
              </div>
            </div>
            <div className="col-12 col-md-6 pt-3 pt-md-0 position-relative">
              <label htmlFor="MandantEmailConfirme" className="form-label">
                Confirmer votre adresse e-mail&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <input
                type="email"
                className="form-control page-1-required confirmMandantEmail_P deletP-group getLabel"
                id="MandantEmailConfirme"
                name="MandantEmailConfirme"
                maxLength={40}
                value={formData.MandantEmailConfirme || ''}
                onChange={handleChangeMandantConfirm}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
                onPaste={(e) => e.preventDefault()}
                required={formData.villeArcachonAutre !== ''}
                placeholder="ex: email@example.com"
              />
              <div className="invalid-tooltip">
                Veuillez entrer une adresse email identique
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-6 position-relative">
              <label htmlFor="MandantTel" className="form-label">
                Votre numéro de téléphone portable&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <input
                type="tel"
                pattern="[ +0-9]+"
                maxLength={15}
                className="form-control page-1-required deletP-group inputReg getLabel"
                id="MandantTel"
                name="MandantTel"
                value={formData.MandantTel || ''}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
                required={formData.villeArcachonAutre !== ''}
                placeholder="ex: 0601020304"
              />
              <div className="invalid-tooltip">
                Veuillez entrer un numéro de téléphone portable valide
              </div>
            </div>
            <div className="col-12 col-md-6 mt-3 mt-md-0 position-relative">
              <label htmlFor="MandantTelFixe" className="form-label">
                Votre numéro de téléphone fixe{' '}
                <span className="text-danger">(facultatif)</span>&nbsp;:
              </label>
              <input
                type="tel"
                pattern="[ +0-9]+"
                className="form-control deletP-group page-1-required inputReg getLabel"
                id="MandantTelFixe"
                name="MandantTelFixe"
                maxLength={15}
                value={formData.MandantTelFixe || ''}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
                placeholder="ex: 0235010203"
              />
              <div className="invalid-tooltip">
                Veuillez entrer un numéro de téléphone valide
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Formulaire Personne Morale */}
      <section
        className={
          (isCommunePersType &&
            formData.PersonneType === 'Une personne morale') ||
          (urlData?.token &&
            isCommunePersType &&
            formData.PersonneType === 'Une personne morale')
            ? 'mt-4 d-block'
            : 'd-none'
        }
      >
        <div className="mt-4">
          <div className="background--warning p-3">
            <div className="row pb-4">
              <div className="col-12 col-md-6 position-relative page-1-required">
                <label htmlFor="MandantRaisSos" className="form-label">
                  Dénomination et raison sociale&nbsp;:&nbsp;
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control page-1-required mandant-group getLabel"
                  id="MandantRaisSos"
                  name="MandantRaisSos"
                  maxLength={50}
                  value={formData.MandantRaisSos || ''}
                  onChange={handleChange}
                  onInput={inputFocus}
                  onBlur={handleTrimValue}
                  required={
                    isCommunePersType &&
                    formData.PersonneType === 'Une personne morale'
                  }
                  autoComplete="nope"
                />
                <div className="invalid-tooltip">
                  Veuillez remplir ce champs obligatoire
                </div>
              </div>
              <div className="col-12 col-md-6 mt-3 mt-md-0 position-relative">
                <label htmlFor="MandantFormeJuridique" className="form-label">
                  Type de société&nbsp;:&nbsp;
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control page-1-required mandant-group getLabel"
                  id="MandantFormeJuridique"
                  name="MandantFormeJuridique"
                  maxLength={20}
                  value={formData.MandantFormeJuridique || ''}
                  onChange={handleChange}
                  onInput={inputFocus}
                  onBlur={handleTrimValue}
                  required={
                    isCommunePersType &&
                    formData.PersonneType === 'Une personne morale'
                  }
                  placeholder="SA, SARL, SCI..."
                  autoComplete="nope"
                />
                <div className="invalid-tooltip">
                  Veuillez remplir ce champs obligatoire
                </div>
              </div>
            </div>
            <div className="row pb-4">
              <div className="col-12 position-relative">
                <label htmlFor="MandantSiret" className="form-label">
                  SIRET&nbsp;:&nbsp;<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  pattern="^\d{14}$"
                  id="MandantSiret"
                  className="form-control page-1-required mandant-group inputReg getLabel"
                  name="MandantSiret"
                  maxLength={14}
                  value={formData.MandantSiret || ''}
                  onChange={handleChange}
                  onInput={inputFocus}
                  onBlur={handleTrimValue}
                  required={
                    isCommunePersType &&
                    formData.PersonneType === 'Une personne morale'
                  }
                  placeholder="N° (14 chiffres)"
                  autoComplete="nope"
                />
                <div className="invalid-tooltip">
                  Veuillez entrer un numéro valide
                </div>
              </div>
            </div>
          </div>
          <p className="mt-4 mb-4">
            <strong>Adresse du siège social à la date de la demande :</strong>
          </p>
          <div className="background--warning p-3">
            <div className="row pb-4">
              <div className="col-12 col-md-3 position-relative">
                <label htmlFor="MandantAdrNum" className="form-label">
                  Numéro de voie&nbsp;:&nbsp;
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  pattern="[0-9]+"
                  className="form-control page-1-required mandant-group getLabel"
                  id="MandantAdrNum"
                  name="MandantAdrNum"
                  maxLength={5}
                  value={formData.MandantAdrNum || ''}
                  onChange={handleChange}
                  onInput={inputFocus}
                  onBlur={handleTrimValue}
                  required={
                    isCommunePersType &&
                    formData.PersonneType === 'Une personne morale'
                  }
                  autoComplete="nope"
                />
                <div className="invalid-tooltip">
                  Veuillez entrer un numéro de voie valide
                </div>
              </div>
              <div className="col-12 col-md-3 mt-3 mt-md-0">
                <div className="position-relative">
                  <label htmlFor="MandantAdrRepetition" className="form-label">
                    Indice de répétition&nbsp;:&nbsp;
                    <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select page-1-required mandant-group getLabel"
                    aria-label="Default select example"
                    id="MandantAdrRepetition"
                    name="MandantAdrRepetition"
                    value={formData.MandantAdrRepetition || ''}
                    onChange={handleChange}
                    onInput={inputFocus}
                    required={
                      isCommunePersType &&
                      formData.PersonneType === 'Une personne morale'
                    }
                  >
                    <option defaultValue=""></option>
                    {optionsIndice &&
                      optionsIndice.map((option, index) => (
                        <option key={index} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                  </select>
                  <div className="invalid-tooltip">
                    Veuillez remplir ce champs obligatoire
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 mt-3 mt-md-0 position-relative">
                <label htmlFor="MandantAdrRue" className="form-label">
                  Type et nom de voie&nbsp;:&nbsp;
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control page-1-required mandant-group getLabel"
                  name="MandantAdrRue"
                  id="MandantAdrRue"
                  maxLength={50}
                  value={formData.MandantAdrRue || ''}
                  onInput={inputFocus}
                  onChange={handleChange}
                  onBlur={handleTrimValue}
                  required={
                    isCommunePersType &&
                    formData.PersonneType === 'Une personne morale'
                  }
                  autoComplete="nope"
                />
                <div className="invalid-tooltip">
                  Veuillez remplir ce champs obligatoire
                </div>
              </div>
            </div>
            <div className="row pb-4">
              <div className="col-12 mt-3 mt-md-0 position-relative">
                <label htmlFor="MandantAdrComp" className="form-label">
                  Complément d'adresse{' '}
                  <span className="text-danger">(facultatif)</span>&nbsp;:&nbsp;
                </label>
                <input
                  type="text"
                  className="form-control mandant-group getLabel"
                  name="MandantAdrComp"
                  id="MandantAdrComp"
                  maxLength={50}
                  value={formData.MandantAdrComp || ''}
                  onInput={inputFocus}
                  onChange={handleChange}
                  onBlur={handleTrimValue}
                  autoComplete="nope"
                />
              </div>
            </div>
            <div className="row pb-4">
              <div className="col-12 col-md-6 position-relative">
                <label htmlFor="MandantAdrCP" className="form-label">
                  Code postal&nbsp;:&nbsp;<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control page-1-required mandant-group inputReg getLabel"
                  name="MandantAdrCP"
                  id="MandantAdrCP"
                  value={formData.MandantAdrCP || ''}
                  onChange={handleChange}
                  onInput={inputFocus}
                  onBlur={handleTrimValue}
                  required={
                    isCommunePersType &&
                    formData.PersonneType === 'Une personne morale'
                  }
                  autoComplete="nope"
                />
                <div className="invalid-tooltip">
                  Veuillez entrer un code postal valide
                </div>
              </div>
              <div className="col-12 col-md-6 mt-3 mt-md-0 position-relative">
                <label htmlFor="MandantAdrVille" className="form-label">
                  Commune&nbsp;:&nbsp;<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control page-1-required mandant-group getLabel"
                  name="MandantAdrVille"
                  id="MandantAdrVille"
                  maxLength={40}
                  value={formData.MandantAdrVille || ''}
                  onChange={handleChange}
                  onInput={inputFocus}
                  onBlur={handleTrimValue}
                  required={
                    isCommunePersType &&
                    formData.PersonneType === 'Une personne morale'
                  }
                  autoComplete="nope"
                />
                <div className="invalid-tooltip">
                  Veuillez remplir ce champs obligatoire
                </div>
              </div>
            </div>
            <div className="row pb-4">
              <div className="col-12 position-relative">
                <label htmlFor="MandantAdrPays" className="form-label">
                  Pays&nbsp;:&nbsp;<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control page-1-required mandant-group getLabel"
                  name="MandantAdrPays"
                  id="MandantAdrPays"
                  maxLength={20}
                  value={formData.MandantAdrPays || ''}
                  onChange={handleChange}
                  onInput={inputFocus}
                  onBlur={handleTrimValue}
                  required={
                    isCommunePersType &&
                    formData.PersonneType === 'Une personne morale'
                  }
                  autoComplete="nope"
                />
                <div className="invalid-tooltip">
                  Veuillez remplir ce champs obligatoire
                </div>
              </div>
            </div>
          </div>
          <p className="mt-4 mb-4">
            <strong>Représentant légal&nbsp;:</strong>
          </p>
          <div className="background--warning p-3">
            <div className="row pb-4">
              <div className="col-12 col-md-2 mt-3 mt-md-0">
                <div className="position-relative">
                  <label htmlFor="MandantCivil" className="form-label">
                    Civilité&nbsp;:&nbsp;
                    <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select page-1-required mandant-group getLabel"
                    aria-label="Default select example"
                    id="MandantCivil"
                    name="MandantCivil"
                    value={formData.MandantCivil || ''}
                    onChange={handleChange}
                    onInput={inputFocus}
                    required={
                      isCommunePersType &&
                      formData.PersonneType === 'Une personne morale'
                    }
                  >
                    <option defaultValue=""></option>
                    {optionsCivilite &&
                      optionsCivilite.map((option, index) => (
                        <option key={index} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                  </select>
                  <div className="invalid-tooltip">
                    Veuillez remplir ce champs obligatoire
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-5 mt-3 mt-md-0 position-relative">
                <label htmlFor="MandantPrenom" className="form-label">
                  Prénom&nbsp;:&nbsp;<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control page-1-required mandant-group getLabel"
                  name="MandantPrenom"
                  id="MandantPrenom"
                  maxLength={30}
                  value={formData.MandantPrenom || ''}
                  onChange={handleChange}
                  onInput={inputFocus}
                  onBlur={handleTrimValue}
                  required={
                    isCommunePersType &&
                    formData.PersonneType === 'Une personne morale'
                  }
                  autoComplete="nope"
                />
                <div className="invalid-tooltip">
                  Veuillez remplir ce champs obligatoire
                </div>
              </div>
              <div className="col-12 col-md-5 mt-3 mt-md-0 position-relative">
                <label htmlFor="MandantNom" className="form-label">
                  Nom de famille&nbsp;:&nbsp;
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control page-1-required mandant-group getLabel"
                  name="MandantNom"
                  id="MandantNom"
                  maxLength={30}
                  value={formData.MandantNom || ''}
                  onChange={handleChange}
                  onInput={inputFocus}
                  onBlur={handleTrimValue}
                  required={
                    isCommunePersType &&
                    formData.PersonneType === 'Une personne morale'
                  }
                  autoComplete="nope"
                />
                <div className="invalid-tooltip">
                  Veuillez remplir ce champs obligatoire
                </div>
              </div>
            </div>
            <div className="row pb-4">
              <div className="col-12 col-md-6 mt-3 mt-md-0">
                <label htmlFor="MandantNomNaissance" className="form-label">
                  Nom de jeune fille{' '}
                  <span className="text-danger">(le cas échéant)</span>&nbsp;:
                </label>
                <input
                  type="text"
                  className="form-control getLabel"
                  name="MandantNomNaissance"
                  id="MandantNomNaissance"
                  maxLength={30}
                  value={formData.MandantNomNaissance || ''}
                  onChange={handleChange}
                  onBlur={handleTrimValue}
                  autoComplete="nope"
                />
              </div>
              <div className="col-12 col-md-6 mt-3 mt-md-0 position-relative">
                <label htmlFor="MandantQualDemandeur" className="form-label">
                  Qualité&nbsp;:&nbsp;<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control page-1-required mandant-group getLabel"
                  name="MandantQualDemandeur"
                  id="MandantQualDemandeur"
                  maxLength={30}
                  value={formData.MandantQualDemandeur || ''}
                  onChange={handleChange}
                  onInput={inputFocus}
                  onBlur={handleTrimValue}
                  required={
                    isCommunePersType &&
                    formData.PersonneType === 'Une personne morale'
                  }
                  autoComplete="nope"
                />
                <div className="invalid-tooltip">
                  Veuillez remplir ce champs obligatoire
                </div>
              </div>
            </div>
            <div className="row pb-4">
              <div className="col-12 col-md-6 position-relative">
                <label htmlFor="MandantEmail" className="form-label">
                  Votre adresse e-mail&nbsp;:&nbsp;
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="email"
                  className="form-control page-1-required mandant-group inputReg getLabel"
                  name="MandantEmail"
                  id="MandantEmail"
                  maxLength={40}
                  value={formData.MandantEmail || ''}
                  onChange={handleChange}
                  onInput={inputFocus}
                  onBlur={handleTrimValue}
                  required={
                    isCommunePersType &&
                    formData.PersonneType === 'Une personne morale'
                  }
                  placeholder="ex: email@example.com"
                  autoComplete="nope"
                />
                <div className="invalid-tooltip">
                  Veuillez entrer une adresse email valide
                </div>
              </div>
              <div className="col-12 col-md-6 pt-3 pt-md-0 position-relative">
                <label htmlFor="MandantEmailConfirme" className="form-label">
                  Confirmer Votre adresse e-mail&nbsp;:&nbsp;
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="email"
                  className="form-control page-1-required confirmMandantEmail_M mandant-group getLabel"
                  name="MandantEmailConfirme"
                  id="MandantEmailConfirme"
                  maxLength={40}
                  value={formData.MandantEmailConfirme || ''}
                  onChange={handleChangeMandantConfirm}
                  onInput={inputFocus}
                  onPaste={(e) => e.preventDefault()}
                  onBlur={handleTrimValue}
                  required={
                    isCommunePersType &&
                    formData.PersonneType === 'Une personne morale'
                  }
                  placeholder="ex: email@example.com"
                  autoComplete="nope"
                />
                <div className="invalid-tooltip">
                  Veuillez entrer une adresse email identique
                </div>
              </div>
            </div>
            <div className="row pb-4">
              <div className="col-12 col-md-6 position-relative">
                <label htmlFor="MandantTel" className="form-label">
                  Votre numéro de téléphone portable&nbsp;:&nbsp;
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="tel"
                  pattern="[0-9+]+"
                  className="form-control page-1-required mandant-group inputReg getLabel"
                  name="MandantTel"
                  id="MandantTel"
                  maxLength={15}
                  value={formData.MandantTel || ''}
                  onChange={handleChange}
                  onInput={inputFocus}
                  onBlur={handleTrimValue}
                  required={
                    isCommunePersType &&
                    formData.PersonneType === 'Une personne morale'
                  }
                  placeholder="ex: 0601020304"
                  autoComplete="nope"
                />
                <div className="invalid-tooltip">
                  Veuillez entrer un numéro de téléphone mobile valide
                </div>
              </div>
              <div className="col-12 col-md-6 mt-3 mt-md-0 position-relative">
                <label htmlFor="MandantTelFixe" className="form-label">
                  Votre numéro de téléphone fixe{' '}
                  <span className="text-danger">(facultatif)</span>&nbsp;:
                </label>
                <input
                  type="tel"
                  pattern="[0-9]+"
                  className="form-control mandant-group page-1-required inputReg getLabel"
                  name="MandantTelFixe"
                  id="MandantTelFixe"
                  maxLength={15}
                  value={formData.MandantTelFixe || ''}
                  onChange={handleChange}
                  onInput={inputFocus}
                  onBlur={handleTrimValue}
                  placeholder="ex: 0235010203"
                  autoComplete="nope"
                />
                <div className="invalid-tooltip">
                  Veuillez entrer un numéro de téléphone valide
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="alert alert-info mt-4">
          <i className="fas fa-info-circle"></i>&nbsp;
          <strong>Pour information :</strong>&nbsp;En cas d'indivision ou de
          SCI, veuillez renseigner le nom de tous les propriétaires figurant sur
          le titre de propriété.
        </div>
      </section>
    </>
  );
};

export default InformationsDemandeur;
